import { Media } from 'media'
import { ComponentType } from 'react'
import { IntroDesktop } from './intro-desktop'
import { IntroMobile } from './intro-mobile'

export const Intro: ComponentType = () => (
  <>
    <Media at="xs">
      <IntroMobile />
    </Media>
    <Media greaterThan="xs">
      <IntroDesktop />
    </Media>
  </>
)
